var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createGetComponentFunc, components, COL_AMOUNT, ROW_AMOUNT, } from '@appspotr/app';
import cloneDeep from 'lodash/cloneDeep';
import { generateUUID } from '../../../utils';
import { LANDSCAPE_RATIO } from './constants';
var getComponentFunc = createGetComponentFunc(components);
export var transformLayoutWithStyle = function (layout, style) {
    if (layout === void 0) { layout = {}; }
    if (style === void 0) { style = {}; }
    var getComponentByName = getComponentFunc(style);
    var styledLayout = Object.keys(layout).map(function (comp) {
        var component = cloneDeep(layout[comp]);
        if (component.name === 'Header' || component.name === 'Body') {
            // TODO: Temporary code to turn Header and Body components into Text, remove once all views have been converted
            component.name = 'Text';
        }
        var styledComp = getComponentByName({
            name: component.name,
            version: component.version,
        });
        var result = __assign(__assign({}, styledComp), component);
        if (styledComp &&
            component.properties &&
            !component.properties.overrideStyle) {
            result.properties.style = cloneDeep(styledComp.properties.style);
        }
        return result;
    });
    return styledLayout.reduce(function (previous, current) {
        previous[current.i] = current;
        return previous;
    }, {});
};
export var toLayoutObject = function (layout) {
    return layout.reduce(function (acc, component) {
        acc[component.i] = component;
        return acc;
    }, {});
};
/** convert a layout object for use in the view builder */
export var toVBLayout = function (layout, portrait, scaleChoice) {
    if (layout === void 0) { layout = {}; }
    if (portrait === void 0) { portrait = true; }
    if (scaleChoice === void 0) { scaleChoice = 'default'; }
    return Object.values(layout).reduce(function (acc, item) {
        var scale = item.scale, rest = __rest(item, ["scale"]);
        if (scale) {
            var chosenScale = scale[scaleChoice] || scale.default;
            var _a = portrait ? chosenScale : chosenScale.landscape, x = _a.x, y = _a.y, w = _a.w, h = _a.h;
            acc[item.i] = __assign(__assign({}, rest), { x: x, y: y, w: w, h: h });
        }
        else {
            acc[item.i] = item;
        }
        return acc;
    }, {});
};
/** convert a view builder layout object back into our api format */
export var toLayout = function (layout, vbLayout, portrait, scaleChoice) {
    if (layout === void 0) { layout = {}; }
    if (vbLayout === void 0) { vbLayout = {}; }
    if (portrait === void 0) { portrait = true; }
    if (scaleChoice === void 0) { scaleChoice = 'default'; }
    return Object.values(vbLayout).reduce(function (acc, item) {
        var x = item.x, y = item.y, w = item.w, h = item.h, _ = item.properties, __ = item.cacheBusterId, rest = __rest(item, ["x", "y", "w", "h", "properties", "cacheBusterId"]);
        var _a = layout[item.i] || {}, _x = _a.x, _y = _a.y, _w = _a.w, _h = _a.h, _group = _a.group, layoutItem = __rest(_a, ["x", "y", "w", "h", "group"]);
        var scale = __assign({}, ((layoutItem && layoutItem.scale) || {
            default: {
                x: x,
                y: y,
                w: w,
                h: h,
                landscape: {
                    x: x,
                    y: y,
                    w: w,
                    h: h,
                },
            },
        }));
        if (portrait) {
            scale[scaleChoice] = __assign(__assign({}, scale[scaleChoice]), { x: x, y: y, w: w, h: h });
        }
        else {
            scale[scaleChoice].landscape = __assign(__assign({}, scale[scaleChoice].landscape), { x: x, y: y, w: w, h: h });
        }
        acc[item.i] = __assign(__assign(__assign({}, layoutItem), rest), { scale: scale });
        return acc;
    }, {});
};
export var createComponent = function (component) {
    var x = component.x, y = component.y, w = component.w, h = component.h, rest = __rest(component, ["x", "y", "w", "h"]);
    return __assign(__assign({}, rest), { i: generateUUID().slice(0, 10), scale: {
            default: {
                x: x,
                y: y,
                w: w,
                h: h,
                landscape: {
                    x: x,
                    y: y,
                    w: w * LANDSCAPE_RATIO,
                    h: h,
                },
            },
        } });
};
export var createComponentCopy = function (component) { return (__assign(__assign({}, component), { i: generateUUID().slice(0, 10) })); };
export var compactFlowLayout = function (layout, portrait) {
    Object.values(layout)
        .sort(function (a, b) { return a.y - b.y; })
        .forEach(function (component) {
        if (!component.group) {
            try {
                component.x = 0;
                component.w = portrait ? COL_AMOUNT : ROW_AMOUNT;
            }
            catch (ex) {
                // sometime assigning to property failed due to immer, will investigate later.
            }
        }
    });
};
export var clearGroupAreas = function (layout) {
    // get group boundaries >> id: top, bottom
    var groupBoundaries = Object.values(layout).reduce(function (acc, comp) {
        // no group, skip
        if (!comp.group) {
            return acc;
        }
        if (!acc[comp.group]) {
            // note the top and bottom of the component
            acc[comp.group] = {
                top: Number(comp.y),
                bottom: Number(comp.y + comp.h),
            };
        }
        else {
            if (acc[comp.group].top > comp.y) {
                // if the top is higher than the group top, replace group top
                acc[comp.group].top = Number(comp.y);
            }
            if (acc[comp.group].bottom < comp.y + comp.h) {
                // if the bottom is not as low as the bottom of the component, replace the group bottom
                acc[comp.group].bottom = Number(comp.y + comp.h);
            }
        }
        return acc;
    }, {});
    var newLayout = {};
    // move components out of group to >> bottom of group
    Object.values(layout).forEach(function (comp) {
        var newComp = __assign({}, comp);
        if (!newComp.group) {
            // check that this component does not fall within a group's area
            Object.values(groupBoundaries).forEach(function (boundary) {
                if (boundary.top < newComp.y && newComp.y < boundary.bottom) {
                    // if the component's top is within a group
                    newComp.y = Number(boundary.bottom);
                }
                var compBottom = Number(newComp.y + newComp.h);
                if (boundary.top < compBottom && compBottom < boundary.bottom) {
                    // if the component's bottom is within a group
                    newComp.y = Number(boundary.bottom);
                }
            });
        }
        newLayout[newComp.i] = newComp;
    });
    return newLayout;
};
